"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sum = void 0;
const aggregate_1 = require("./aggregate");
function sum(src, selector) {
    if (!selector) {
        return (0, aggregate_1.aggregate)(src, (prev, curr) => {
            if (typeof curr !== 'number') {
                throw new Error('sum can only be used with numbers');
            }
            return prev + curr;
        });
    }
    return (0, aggregate_1.aggregate)(src, 0, (prev, curr) => prev + selector(curr));
}
exports.sum = sum;
//# sourceMappingURL=sum.js.map